import get from "lodash/get";
import {useFormContext} from "react-hook-form";
import {ActionMeta} from "react-select";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {ComponentStatus} from "@/lib/types/statuspages.ts";
import ComponentStatusSelect from "@/pages/statuspages/tabs/components/ComponentStatusSelect/ComponentStatusSelect.tsx";

interface ComponentStatusSelectFieldProps extends SelectFieldBaseProps {
  options: ComponentStatus[];
  onChange?: (value: ComponentStatus | null, action: ActionMeta<ComponentStatus>) => void;
}

export const ComponentStatusSelectField = ({name, options, onChange, ...props}: ComponentStatusSelectFieldProps) => {
  const {
    watch,
    setValue,
    formState: {defaultValues},
  } = useFormContext();
  const defaultValue = get(defaultValues, watch(name));
  const value = watch(name);

  return (
    <SelectField
      name={name}
      {...props}
      select={
        <ComponentStatusSelect
          options={options}
          defaultValue={defaultValue}
          value={options.find((v) => v.value === value)}
          onChange={(v, actionMeta) => {
            setValue(name, v?.value);
            onChange?.(v, actionMeta);
          }}
        />
      }
    />
  );
};
